import { useEffect } from 'react'
import confetti from 'canvas-confetti'

const BRAND_COLORS = ['#3076E2', '#1D3557', '#F4B400', '#34A853', '#ffffff']

export function fireConfetti({ origin, particleCount = 120, spread = 70 } = {}) {
  confetti({
    particleCount,
    spread,
    origin: origin || { y: 0.6 },
    colors: BRAND_COLORS,
    scalar: 1.0,
    ticks: 200,
  })
}

export function fireBigCelebration() {
  const duration = 1200
  const end = Date.now() + duration
  ;(function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors: BRAND_COLORS })
    confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors: BRAND_COLORS })
    if (Date.now() < end) requestAnimationFrame(frame)
  })()
}

/**
 * Drop-in component: <ConfettiBurst trigger={someBoolean} />
 * Fires a burst whenever `trigger` flips to truthy.
 */
export default function ConfettiBurst({ trigger, big = false }) {
  useEffect(() => {
    if (!trigger) return
    if (big) fireBigCelebration()
    else fireConfetti()
  }, [trigger, big])
  return null
}
